import {
  LOGIN,
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  LOGOUT,
  LOGOUT_SUCCESS,
  DISMISS_MESSAGE,
  UPDATE_USER_INFO,
  SET_IS_PBS_AUTHORITY_REQUIRED,
  SET_IS_RE_AUTHENTICATION_REQUIRED,
  SET_PRESCRIBING_MESSAGE,
  UPDATE_EBS_NUMBER,
  SAVE_ATTACHMENT,
  DELETE_ATTACHMENT,
  SAVE_DRUG_INFO,
  DELETE_DRUG_INFO,
  REMOVE_ASSESSMENT_DATA,
  UPDATE_MIMS_EULA_REVISION,
  UPDATE_MIMS_TERMS_REVISION
} from "../constants/auth";

export const loginUser = data => ({
  type: LOGIN,
  payload: data
});

export const loginUserSuccess = data => ({
  type: LOGIN_SUCCESS,
  payload: data
});

export const loginUserError = data => ({
  type: LOGIN_ERROR,
  payload: data
});

export const logOutUser = data => ({
  type: LOGOUT,
  payload: data
});

export const logOutUserSuccess = () => ({
  type: LOGOUT_SUCCESS
});

export const dismissMessage = () => ({
  type: DISMISS_MESSAGE
});

export const updateUserData = data => ({
  type: UPDATE_USER_INFO,
  payload: data
});

export const setIsPBSAuthorityRequired = data => ({
  type: SET_IS_PBS_AUTHORITY_REQUIRED,
  payload: data
});

export const updateEbsNumber = data => ({
  type: UPDATE_EBS_NUMBER,
  payload: data
});

export const saveNoteAttachment = data => ({
  type: SAVE_ATTACHMENT,
  payload: data
});

export const deleteNoteAttachment = data => ({
  type: DELETE_ATTACHMENT,
  payload: data
});


export const saveDrugInfo = data => ({
  type: SAVE_DRUG_INFO,
  payload: data
});

export const deleteDrugInfo = data => ({
  type: DELETE_DRUG_INFO,
  payload: data
});

export const removeAssessmentData = () => ({
  type: REMOVE_ASSESSMENT_DATA
})

export const updateMimsEulaRevision = data => ({
  type: UPDATE_MIMS_EULA_REVISION,
  payload: data
});

export const updateMimsTermsRevision = data => ({
  type: UPDATE_MIMS_TERMS_REVISION,
  payload: data
});
